import axios, { AxiosInstance } from 'axios';
import { useToast } from 'vue-toastification';
import { store, MutationTypes } from 'store';

const toast = useToast();

const API: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_INTERNAL_API,
    headers: { 'Content-Type': 'application/json' },
    timeout: 10000,
    withCredentials: false,
});

// Todo [+]: Add response/request Handlers
API.interceptors.request.use((request) => {
    // Start the loader
    store.commit(MutationTypes.TOGGLE_HTTP_LOADER, true)
    // Return the request data
    return request;
});

// response interceptor
API.interceptors.response.use((response) => {
    // Stop the loader
    store.commit(MutationTypes.TOGGLE_HTTP_LOADER, false)

    // do something with the response data
    return response;
}, error => {
    // Stop the loader
    store.commit(MutationTypes.TOGGLE_HTTP_LOADER, false)

    if (error.response.status === 401) {
        // Emit an Error toast
        toast.error('Sign in again!');

        // Remove the details save in LS
        localStorage.removeItem('authToken')
        localStorage.removeItem('user')

        // Trigger a page reload
        location.reload()
    }

    // Reject the request
    return Promise.reject(error)
});

export default API;
